"use strict";
/**
 * @hermis/solana-headless-errors
 *
 * Type-safe error handling system for the Hermis Solana Headless SDK
 *
 * Features:
 * - Numeric error codes (tree-shakeable)
 * - Type-safe context data
 * - Message interpolation
 * - Dev/Prod modes
 * - Error chaining
 * - Type guards
 *
 * @example
 * ```ts
 * import { HermisError, HERMIS_ERROR__WALLET_CONNECTION__FAILED } from '@hermis/solana-headless-errors';
 *
 * throw new HermisError(
 *   HERMIS_ERROR__WALLET_CONNECTION__FAILED,
 *   { walletName: 'Phantom', reason: 'User rejected' }
 * );
 * ```
 *
 * @example Type-safe error handling
 * ```ts
 * import { isHermisError, HERMIS_ERROR__WALLET_CONNECTION__FAILED } from '@hermis/solana-headless-errors';
 *
 * try {
 *   await wallet.connect();
 * } catch (error) {
 *   if (isHermisError(error, HERMIS_ERROR__WALLET_CONNECTION__FAILED)) {
 *     // TypeScript knows error.context has walletName, reason, etc.
 *     console.log(`Failed to connect to ${error.context.walletName}`);
 *   }
 * }
 * ```
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HERMIS_ERROR_MESSAGES = exports.formatContext = exports.getErrorMessageTemplate = exports.formatErrorMessage = exports.isUserRejection = exports.wrapError = exports.createHermisError = exports.isHermisError = exports.HermisError = void 0;
// Export all error codes
__exportStar(require("./codes"), exports);
// Export error class and utilities
var error_1 = require("./error");
Object.defineProperty(exports, "HermisError", { enumerable: true, get: function () { return error_1.HermisError; } });
Object.defineProperty(exports, "isHermisError", { enumerable: true, get: function () { return error_1.isHermisError; } });
Object.defineProperty(exports, "createHermisError", { enumerable: true, get: function () { return error_1.createHermisError; } });
Object.defineProperty(exports, "wrapError", { enumerable: true, get: function () { return error_1.wrapError; } });
// Export utility functions
var utils_1 = require("./utils");
Object.defineProperty(exports, "isUserRejection", { enumerable: true, get: function () { return utils_1.isUserRejection; } });
// Export message formatting utilities (useful for custom error handling)
var message_formatter_1 = require("./message-formatter");
Object.defineProperty(exports, "formatErrorMessage", { enumerable: true, get: function () { return message_formatter_1.formatErrorMessage; } });
Object.defineProperty(exports, "getErrorMessageTemplate", { enumerable: true, get: function () { return message_formatter_1.getErrorMessageTemplate; } });
Object.defineProperty(exports, "formatContext", { enumerable: true, get: function () { return message_formatter_1.formatContext; } });
// Export error messages (useful for testing and documentation)
var messages_1 = require("./messages");
Object.defineProperty(exports, "HERMIS_ERROR_MESSAGES", { enumerable: true, get: function () { return messages_1.HERMIS_ERROR_MESSAGES; } });
